const dtGenerator       = require('../../../../../components/dt/dt-generator')
const dtHandler         = require('../../../../../components/dt/dt-handler')
const retailDtSearch    = require('./retail-dt-search')
const retailMenu        = require('./retail-menu')
const handler           = require('./retail-fullcont-handler')
const { organizeRow }   = require('./retail-dt-handler')
const { tableDetail }   = require('./retail-dt-handler')

var htmlDt = {}
var HTMLwasSelected = false
const INITIAL_ROWS = 20

function HTMLselect() {
      dtHandler.HTMLselect('retail-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected = true
}

export function start(detail) {
      if (!HTMLwasSelected) { HTMLselect() }
      obj[detail.act].start(detail)
}

const obj = {
      addRow:        { start: (detail) => { dtGenerator.addRow(detail, htmlDt)        } },
      tableOptions:  { start: (detail) => { retailMenu.start(detail, htmlDt, 'htmlFc') } },
      trMenu:        { start: (detail) => { retailMenu.start(detail, htmlDt, 'htmlFc') } },
      updateRow:     { start: (detail) => { dtGenerator.updateRow(detail, htmlDt)     } },
      filter:        { start: (detail) => { retailDtSearch.filter(detail, htmlDt)     } },
      filterShowHide:{ start: (detail) => { retailDtSearch.filterShowHide(detail, htmlDt) } },
      loadMore:      { start: (detail) => { retailDtSearch.loadMore(detail, htmlDt)   } },
      searching:     { start: (detail) => { retailDtSearch.searching(detail, htmlDt)  } },
      select:        { start: (detail) => { selectInitial(detail)                     } },
      th:            { start: (detail) => { retailDtSearch.th(detail, htmlDt)         } },
      pdfMenudt:     { start: (detail) => { handler.pdfMenudt(detail)                 } },
}

function selectInitial(detail) {
      retailDtSearch.select(detail, htmlDt, true, () => {
            htmlDt.footer.setAttribute('data-limit', 10)
      }, INITIAL_ROWS)
}
